import { apiRoutes } from "@/services/api/api-routes"
import { axiosClient } from "@/services/api/axiosClient"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"
import { Scope } from "@/models/Principle"

interface Args {
  principleId: string
  title?: string
  description?: string
  enabled?: boolean
  scopesToAdd?: Scope[]
  scopesToRemove?: Scope[]
  scopes?: Scope[]
}

export const useUpdateReviewerPrinciples = () => {
  const queryClient = useQueryClient()

  const updateReviewerPrinciple = useCallback(
    async (options: Args) => await axiosClient.patch(apiRoutes.reviewerPrinciples.patch(options.principleId), options),
    []
  )

  const {
    data,
    mutateAsync: mutate,
    status
  } = useMutation({
    mutationKey: ["updateReviewerPrinciple"],
    mutationFn: updateReviewerPrinciple,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reviewerPrinciples"] })
    }
  })

  return { data, mutate, status }
}
